module.exports = __webpack_public_path__ + "img/znjj.39aa27a7.png";